import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Building, Wrench, Home } from 'lucide-react';

const services = [
  {
    title: 'Freight & Logistics',
    icon: Truck,
    description: 'Haulage, cargo transport, cold chain logistics, warehousing, customs clearance.',
  },
  {
    title: 'Infrastructure & Civil Engineering',
    icon: Building,
    description: 'Roads, bridges, drainage, water/sewer, telecom/power.',
  },
  {
    title: 'Specialized Construction Services',
    icon: Wrench,
    description: 'Steel, electrical, HVAC, roofing.',
  },
  {
    title: 'General Construction Services',
    icon: Home,
    description: 'Residential/commercial builds, renovation, project management.',
  },
];

const cardVariants = {
  offscreen: { y: 100, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: { type: 'spring', bounce: 0.3, duration: 0.8 }
  }
};

const Services = () => {
  return (
    <section id="services" className="relative overflow-hidden py-32 bg-royalBlue text-white">
      <div
        className="absolute inset-0 bg-cover bg-center brightness-[0.3] z-0"
        style={{ backgroundImage: "url('/images/construction-bg.jpg')" }}
        aria-hidden="true"
      ></div>

      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="relative z-10 max-w-7xl mx-auto px-6"
      >
        <h2 className="text-5xl font-extrabold text-gold text-center mb-6 drop-shadow-lg">
          Our Core Services
        </h2>
        <p className="text-center max-w-3xl mx-auto text-gray-300 mb-16">
          Delivering excellence in logistics, infrastructure, and construction across Africa.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              className="bg-white/10 backdrop-blur-lg p-6 rounded-2xl shadow-xl border border-white/10 hover:shadow-gold transition duration-300"
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.4 }}
              variants={cardVariants}
            >
              <service.icon className="w-10 h-10 text-gold mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">{service.title}</h3>
              <p className="text-gray-200 text-sm leading-relaxed">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Services;
